// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import $ from 'jquery';
/* 引入swiper */
import VueAwesomeSwiper from 'vue-awesome-swiper';
// 引入图片预览工具
import Viewer from 'v-viewer'
import  'viewerjs/dist/viewer.css'

Vue.use(VueAwesomeSwiper /* { default options with global component } */);

import { WOW } from 'wowjs'
import animated from 'wowjs/css/libs/animate.css'


import Swiper from "swiper";
import 'swiper/css/swiper.css' // 全局引入swiper样式




Vue.use(ElementUI);
// 引入less
// import less from 'less'
// Vue.use(less)

// 引入图片预览工具
Vue.use(Viewer,{
  defaultOptions: {
    navbar: true, // 底部缩略图
    toolbar: true, // 底部工具栏
    button: true, // 右上角按钮
    title: true, // 当前图片标题
    movable: true // 是否可以移动
  }
})

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
router.afterEach(() => {
  window.scrollTo(0, 0); // 切换路由之后滚动条始终在最顶部
});
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
  document.title = to.meta.title
  }
  next()
  })



// WEBPACK FOOTER //
// ./src/main.js